import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {GatewayTypeOPEEnum} from "./GatewayTypeOPEEnum";

class O {
}

/**
 * O Inner Class
 */
class I {
  id!: number;
}

export class DelGatewayTypeCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(GatewayTypeOPEEnum.DelGatewayType);
    this.i = new I();
    this.o = new O();
  }
}
